import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Package, Check, X } from '@phosphor-icons/react';
import { OrderItemsDetail } from './OrderItemsDetail';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STEPS = [
  { key: 'pendente', label: 'Recebido' },
  { key: 'preparando', label: 'Preparando' },
  { key: 'entregue', label: 'Entregue' },
];
const money = (v) => `$ ${(Number(v) || 0).toFixed(2)}`;

const OrderSteps = ({ status, testid }) => {
  if (status === 'cancelado') {
    return <p className="inline-flex items-center gap-1 text-xs font-semibold text-[#9B2226]" data-testid={testid}><X size={14} /> Pedido cancelado</p>;
  }
  const current = Math.max(0, STEPS.findIndex((s) => s.key === status));
  return (
    <div className="flex items-center" data-testid={testid}>
      {STEPS.map((s, i) => (
        <div key={s.key} className="flex items-center flex-1 last:flex-none">
          <div className="flex flex-col items-center gap-1">
            <span className={`w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-bold transition-colors ${i <= current ? 'bg-[#E85D04] text-white' : 'bg-[#F5F2EB] text-[#A8A29E] border border-[#E6E2D8]'}`}>
              {i < current || (i === current && status === 'entregue') ? <Check size={14} weight="bold" /> : i + 1}
            </span>
            <span className={`text-[10px] font-semibold ${i <= current ? 'text-[#1A1A1A]' : 'text-[#A8A29E]'}`}>{s.label}</span>
          </div>
          {i < STEPS.length - 1 && <div className={`flex-1 h-0.5 mx-1 mb-4 ${i < current ? 'bg-[#E85D04]' : 'bg-[#E6E2D8]'}`} />}
        </div>
      ))}
    </div>
  );
};

const PaymentLine = ({ o, i }) => {
  if (o.payment_mode === 'deposit' && o.payment_status !== 'pago') {
    return (
      <div className="text-[11px] text-[#73706A] flex flex-wrap items-center gap-x-3 gap-y-1">
        <span>Sinal {money(o.deposit_amount)}: <b>{o.deposit_status}</b></span>
        <span>Saldo {money(o.balance_amount)}: <b>{o.balance_status}</b></span>
        {o.deposit_status === 'pago' && o.balance_status !== 'pago' && (
          <Link to={`/pedido/${o.collection}/${o.id}`} className="text-[#E85D04] font-semibold underline" data-testid={`my-order-pay-balance-${i}`}>Pagar saldo</Link>
        )}
      </div>
    );
  }
  return <p className="text-[11px] text-[#73706A]">Pagamento: <b className={o.payment_status === 'pago' ? 'text-[#2D6A4F]' : ''}>{o.payment_status || 'pendente'}</b></p>;
};

export const MyOrders = ({ refreshKey }) => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    axios.get(`${API}/portal/my-orders`, { withCredentials: true }).then((r) => setOrders(r.data || [])).catch(() => {});
  }, [refreshKey]);

  if (orders.length === 0) return null;
  return (
    <div className="bg-white border border-[#E6E2D8] rounded-lg p-6" data-testid="my-orders">
      <h2 className="font-['Outfit'] font-semibold text-lg text-[#1A1A1A] mb-4 flex items-center gap-2">
        <Package size={20} className="text-[#E85D04]" /> Meus Pedidos
      </h2>
      <div className="space-y-4">
        {orders.map((o, i) => (
          <div key={o.id} className="p-4 rounded-lg border border-[#E6E2D8] bg-[#FDFBF7] space-y-3" data-testid={`my-order-${i}`}>
            <div className="flex items-start justify-between gap-3">
              <OrderItemsDetail items={o.items} testid={`my-order-items-${i}`} />
              <div className="text-right shrink-0">
                <p className="font-bold text-[#1A1A1A]">{money(o.amount)}</p>
                <p className="text-[11px] text-[#73706A]">{o.created_at ? new Date(o.created_at).toLocaleDateString('pt-BR') : ''}</p>
              </div>
            </div>
            <OrderSteps status={o.status} testid={`my-order-status-${i}`} />
            <PaymentLine o={o} i={i} />
          </div>
        ))}
      </div>
    </div>
  );
};
